import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Grid } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { selectedIsShopLogin } from "../../store/slices/appSettings";
import { logoutWithWorker } from "../../utils";
import { appListing } from "../../utils/linkSheet";
import openNewTab from "../../utils/openNewTab";
import IgErrorBoundary from "../Utils/IgErrorBoundary";

import { ShopLogin } from "./ShopLogin";
import { UserPasswordLogin } from "./UserPasswordLogin";

const PREFIX = "LoginPage";

const classes = {
  paper: `${PREFIX}-paper`,
  avatar: `${PREFIX}-avatar`,
};

const StyledContainer = styled(Container)(({ theme }) => ({
  [`& .${classes.paper}`]: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  [`& .${classes.avatar}`]: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
}));

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="intelligems.io/">
        Intelligems, Inc
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function LoginPage() {
  const isShopLogin = useSelector(selectedIsShopLogin);
  useEffect(() => {
    if (window.location.href.includes("logout")) {
      logoutWithWorker();
    }
  }, []);

  return (
    <StyledContainer maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <IgTypography component="h1" variant="h5">
          Sign in
        </IgTypography>
        <Grid
          item
          xs
          style={{ width: "100%", marginTop: "5px", marginBottom: "5px" }}
        >
          <IgButton
            onClick={() => {
              openNewTab(appListing, "Login Page - Download App");
            }}
            fullWidth
            size={"medium"}
            variant={"text"}
          >
            Don't have an account? Download Intelligems now!
          </IgButton>
        </Grid>
        <IgErrorBoundary>
          {isShopLogin ? <ShopLogin /> : <UserPasswordLogin />}
        </IgErrorBoundary>
      </div>
      <Box mt={2}>
        <Copyright />
      </Box>
    </StyledContainer>
  );
}
